// removed by extract-text-webpack-plugin
module.exports = {"company-letter-blockquote":"company-letter-blockquote___oEYeT h4___kHWTn"};